import React from 'react';
import { IconProps } from '.';

const SvgNumTenFill = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        d='M2 5.333A3.333 3.333 0 0 1 5.333 2h13.334A3.333 3.333 0 0 1 22 5.333v13.334A3.333 3.333 0 0 1 18.667 22H5.333A3.333 3.333 0 0 1 2 18.667V5.333Z'
      />
      <path
        fill={secondaryColor}
        d='M9.279 7.017h-1.85L5.1 8.502v1.732L7.26 8.879h.053v7.566h1.966V7.017ZM15.125 16.575c2.357 0 3.79-1.745 3.79-4.844 0-3.08-1.44-4.844-3.79-4.844s-3.789 1.765-3.789 4.844c0 3.086 1.426 4.844 3.789 4.844Zm-1.784-4.844c0-2.155.697-3.236 1.784-3.242 1.087.006 1.79 1.087 1.784 3.242.006 2.174-.69 3.23-1.784 3.23s-1.797-1.056-1.784-3.23Z'
      />
    </svg>
  );
};

export default SvgNumTenFill;
